import { AnuncioChip } from '../../anuncio/models/anuncio-chip.model';

export class FiltroDesbloqueioAnuncio {
  anuncios: AnuncioChip[];
}
